import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Button, Form, FormGroup, Label } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import cx from 'classnames';
import { email, length, required } from 'redux-form-validators';

// components
import FormField from '../../components/form/field/field';

// modules
import styles from '../../components/form/form.module.scss';

let ContactForm = (
  {
    handleSubmit,
    onCancelClick,
    states,
    invalid,
    valid,
    reset,
    error,
    submitSucceeded,
    submitting,
    ...props
  },
  context
) => {
  const BS = context.theme;

  return (
    <Form onSubmit={handleSubmit}>
      {error && <Alert color="danger">{error}</Alert>}
      {submitSucceeded && <Alert color="success">Information sent!</Alert>}
      <h5>Your Information</h5>
      <FormGroup>
        <Label className={styles.label} for="fromName">
          Name
        </Label>
        <Field
          name="fromName"
          type="text"
          placeholder="Name"
          component={FormField}
          required
          validate={[required(), length({ max: 255 })]}
        />
      </FormGroup>
      <FormGroup>
        <Label className={styles.label} for="fromEmail">
          Email Address:
        </Label>
        <Field
          name="fromEmail"
          type="email"
          placeholder="Email Address"
          component={FormField}
          required
          validate={[required(), email(), length({ max: 255 })]}
        />
      </FormGroup>
      <h5>Recipient's Information</h5>
      <FormGroup>
        <Label className={styles.label} for="toName">
          Name
        </Label>
        <Field
          name="toName"
          type="text"
          placeholder="Name"
          component={FormField}
          required
          validate={[required(), length({ max: 255 })]}
        />
      </FormGroup>
      <FormGroup>
        <Label className={styles.label} for="toEmail">
          Email Address:
        </Label>
        <Field
          name="toEmail"
          type="email"
          placeholder="Email Address"
          component={FormField}
          required
          validate={[required(), email(), length({ max: 255 })]}
        />
      </FormGroup>
      <FormGroup>
        <Label className={styles.label} for="message">
          Message
        </Label>
        <Field
          name="message"
          type="textarea"
          placeholder=""
          component={FormField}
          className={styles.responsiveTextarea}
          validate={[length({ max: 10000 })]}
        />
      </FormGroup>
      <div className={cx(BS.dFlex, BS.justifyContentBetween, BS.mb3)}>
        <Button
          color="warning"
          onClick={e => {
            reset(e);
            if (onCancelClick) {
              onCancelClick(e);
            }
          }}
        >
          Cancel
        </Button>
        <Button
          color="primary"
          type="submit"
          disabled={invalid || submitSucceeded || submitting}
        >
          Submit
        </Button>
      </div>
    </Form>
  );
};

ContactForm.contextTypes = {
  theme: PropTypes.object
};

export default reduxForm({
  form: 'email-listings-form'
})(ContactForm);



// WEBPACK FOOTER //
// ./src/forms/email-listings-form/email-listings-form.js